import { cn } from '@/lib/cn';

/**
 * What an action IS to the operator — its colour (PO 2026-10-27: «los botones de la
 * derecha están todos blancos… algunos deban tener color, sobre todo los accionables
 * porque es lo que sigue o porque no hay hotel o no hay vuelo… unificá el diseño y la
 * alineación»): `next` — the step «Lo que sigue» names (filled Nexa blue); `act` —
 * another write the operator can make (tinted blue); `alert` — what is missing (no
 * hotel, no flight, no contact, a failed card: tinted rose); `quiet` — only a look.
 */
export type ActionTone = 'next' | 'act' | 'alert' | 'quiet';

export const ACTION_TONE: Readonly<Record<ActionTone, string>> = {
  next: 'border-transparent bg-primary text-primary-foreground hover:bg-primary/90 hover:text-primary-foreground',
  act: 'border-primary/40 bg-primary/10 text-primary hover:bg-primary/15 hover:text-primary',
  alert:
    'border-rose-300 bg-rose-50 text-rose-800 hover:bg-rose-100 hover:text-rose-900 dark:border-rose-500/40 dark:bg-rose-500/10 dark:text-rose-300 dark:hover:bg-rose-500/20 dark:hover:text-rose-200',
  quiet: 'border-border bg-background text-foreground hover:bg-muted hover:text-foreground',
};

/** The lanes' right column: one width, one height, the label left and a chevron right. */
export const LANE_ACTION = 'h-11 w-full justify-between font-semibold';
/** The side column's cards («Atento a», «Te necesitan»): one height, in a wrapping row. */
export const CARD_ACTION = 'h-9 px-3 text-sm font-semibold';

/** A lane action's classes for a tone. */
export const laneAction = (tone: ActionTone) => cn(LANE_ACTION, ACTION_TONE[tone]);
/** A card action's classes for a tone. */
export const cardAction = (tone: ActionTone) => cn(CARD_ACTION, ACTION_TONE[tone]);
